import { Entity } from '@backstage/catalog-model';

const ENVS_ANNOTATION = 'rescale.com/environments';

export function getEnvironmentsFromEntity(entity: Entity): string[] {
  const value = entity.metadata.annotations?.[ENVS_ANNOTATION];
  if (!value) return [];
  return value.split(',').map(e => e.trim()).filter(Boolean);
}
